import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { Component, useState } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { useForm } from 'react-hook-form';
import { Avatar, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import {
  IDiscussionResponse,
  useSaveDiscussionReplyMutation
} from 'redux/reducers/user/dashboard/tms-discussion';
import { BiSend } from 'react-icons/bi';
// import SendIcon from '@mui/icons-material/Send';
// import { IDiscussionResponse, useSaveDiscussionReplyMutation } from '@tms/services/tms-discussion';

const CommentFooter = ({
  data,
  sessionId,
  courseTitle
}: {
  data: IDiscussionResponse;
  sessionId: string;
  courseTitle: string;
}) => {
  const defaultValuesReply = {
    user: null as number | null,
    reply: ''
  };
  const {
    control: controlReply,
    setValue: setReplyValue,
    handleSubmit: handleSubmitReply,
    getValues: getReplyValues,
    reset: resetReply,
    watch: watchReply
  } = useForm({
    defaultValues: defaultValuesReply
  });
  const { mutateAsync: addDiscussionReply, isLoading: isSavingReply } =
    useSaveDiscussionReplyMutation();

  function sendReply(userId: number, parentId: number | string) {
    const requestBody = {
      user: userId,
      content: getReplyValues('reply')
    };
    addDiscussionReply({
      sessionId: sessionId,
      courseTitle: courseTitle,
      parentId: parentId,
      replyDetail: requestBody
    });
    resetReply(defaultValuesReply);
  }
  const replyValue = watchReply('reply');
  return (
    <Box m={2}>
      <Stack
        direction="row"
        justifyContent="flex-start"
        p={1}
        sx={{
          backgroundColor: 'white',
          height: 1
        }}
        spacing={1}
      >
        <Avatar alt={data.user.email} src={data.user.profile ?? ''} />
        <Box
          sx={{
            width: '100%'
          }}
        >
          <TextField
            id="outlined-password-input"
            size={'small'}
            label="Add a comment"
            type="text"
            name="reply"
            value={replyValue}
            onChange={(e) => {
              setReplyValue('reply', e.target.value);
            }}
            autoComplete="current-password"
            sx={{
              width: 'inherit'
            }}
            InputProps={{
              endAdornment: (
                // <InputAdornment position="end">
                <IconButton onClick={() => sendReply(data.user.id, data.id)}>
                  <BiSend />
                  {/* <SendIcon
                      sx={{
                        color: 'blue'
                      }}
                    /> */}
                </IconButton>
                // </InputAdornment>
              )
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default CommentFooter;
